import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const SubscriptionService = sdk.getService('SubscriptionService');

export const useSubscriptionDetail = (subscriptionId: string | null | undefined) => {
  const { isLoading, data, error, refetch } = useQuery({
    queryKey: ['subscriptions', subscriptionId],
    queryFn: () => SubscriptionService.getMySubscriptionDetail(subscriptionId!),
    enabled: !!subscriptionId
  });

  return {
    subscription: data,
    refetch,
    isLoading,
    error
  };
};
